let completedToken: string | undefined;
const pending = new Map<string, Promise<boolean>>();

export function syncCustomerPricing(token: string): Promise<boolean> {
  if (completedToken === token) return Promise.resolve(true);
  const existing = pending.get(token);
  if (existing) return existing;
  const work = fetch('/api/sync-customer', {
    method: 'POST',
    credentials: 'omit',
    headers: { Authorization: 'Bearer ' + token },
    signal: AbortSignal.timeout(35_000),
  })
    .then(async (response) => {
      const ready = response.ok && (await response.json()).success === true;
      if (ready) completedToken = token;
      return ready;
    })
    .catch(() => false)
    .finally(() => pending.delete(token));
  pending.set(token, work);
  return work;
}
